import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { recordPotentialInitiatingPage } from '@lib/checkout/initiating-page';
import { recordFirstLandingPage } from '@lib/attribution/first-landing-page';

/**
 * Records the current page as a potential checkout-initiating page on mount
 * and after every client-side navigation, so /checkout-stripe can report
 * where the buyer actually clicked "buy" from (`converted_page_url`).
 * FFH-1849: also seeds the write-once `first_landing_page` cookie on the same
 * events, so the first page the buyer arrived on is captured for attribution.
 * Mirrors `useCaptureAttributionFromUrl`: mount at the top of `HubApp`,
 * outside the route-keyed error boundary, so the subscription survives
 * client navigations.
 */
export const useRecordInitiatingPage = (): void => {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const record = (): void => {
      recordPotentialInitiatingPage(window.location.pathname);
      recordFirstLandingPage(window.location.pathname);
    };

    record();
    router.events.on('routeChangeComplete', record);
    return () => {
      router.events.off('routeChangeComplete', record);
    };
  }, [router.events]);
};
